import { render } from "./InvestmentTrimmed.vue?vue&type=template&id=7ca36429&scoped=true"
import script from "./InvestmentTrimmed.vue?vue&type=script&lang=js"
export * from "./InvestmentTrimmed.vue?vue&type=script&lang=js"

import "./InvestmentTrimmed.vue?vue&type=style&index=0&id=7ca36429&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca36429"]])

export default __exports__